app.service('productArchive',function(productCardConfig, console) {
	var $self, $recommendedList;
	var config;

	function loadRecomendedSuccess(html){
		$recommendedList.html(html);
		setElements();
	}
	function loadRecomended(){
		$.ajax({
			url: '/not-active-recommended-products.ltr',
			type: "POST",
			data: {
				id: config.id
			},
			success: function(data) {
				loadRecomendedSuccess(data);
			},
			error: function() {
				console.log('Błąd odczytu rekomendacji produktów archiwalnych/nieaktywnych');
			},
			complete: function() {
				$recommendedList.removeClass('loading');
			}
		});
	}
	function setElements(){
		$self = $("#product");
		$recommendedList = $("#recommended-products-container", $self);
		$products= $('.product-archive-list', $self);
		config=productCardConfig.getData();
	}

	function init() {
		setElements();
		loadRecomended();
	}
	return {
		init:init
	};
});
